import {
  ClipboardList,
  Clock,
  DollarSign,
  FileSpreadsheet,
  Gauge,
  Package,
  ShoppingBag,
  User,
  Users,
  Wallet,
  Zap,
} from 'lucide-react';

const menuData: any = [
  // {
  //   label: 'Tổng quan',
  //   isTitle: true,
  // },
  // {
  //   id: 'statistical-report',
  //   label: 'Tổng quan',
  //   link: '/statistical-report',
  //   permissionFeature: 'DASHBOARD_INVENTORY',
  //   icon: <BarChart />,
  // },
  {
    id: 'fast-access',
    label: 'Thao tác nhanh',
    link: '/fast-access',
    icon: <Zap />,
    mobileOnly: true,
  },

  // {
  //   id: 'report',
  //   label: 'Report',
  //   link: '/report',
  //   icon: <FileText />,
  //   subItems: [
  //     {
  //       id: 'daily-debt',
  //       label: 'Debt',
  //       link: '/report/debt',
  //     },
  //   ],
  // },
  {
    label: 'Công nợ',
    isTitle: true,
  },
  {
    id: 'customer',
    label: 'Khách hàng',
    link: '/customer',
    icon: <User />,
    permissionFeature: 'CUSTOMER',
  },

  // {
  //   id: 'invoice',
  //   label: 'Invoice',
  //   link: '/invoice',
  //   icon: <File />,
  //   permissionFeature: 'RECEIPT',
  // },

  {
    label: 'Báo cáo',
    isTitle: true,
  },
  {
    id: 'debt-data',
    label: 'Báo cáo tài chính',
    link: '/debt-data',
    icon: <Wallet />,
    permissionFeature: 'DASHBOARD_DEBT',
  },
  {
    id: 'inventory-report',
    label: 'Báo cáo vật tư',
    link: '/inventory/report',
    icon: <FileSpreadsheet />,
    permissionFeature: 'DASHBOARD_INVENTORY',
  },

  {
    label: 'Vận hành',
    isTitle: true,
  },
  {
    id: 'shift-handovers',
    label: 'Giao ca',
    link: '/shift-handovers',
    icon: <ClipboardList />,
    permissionFeatures: ['SHIFT_MANAGEMENT', 'SHIFT_MEMBERSHIP'],
  },
  {
    id: 'inventory-management',
    label: 'Xuất/Nhập vật tư',
    link: '/inventory-management',
    icon: <Package />,
    permissionFeature: 'INVENTORY_DOC',
  },
  {
    id: 'expense-management',
    label: 'Quản lý chi phí',
    link: '/expense-management',
    icon: <DollarSign />,
    permissionFeature: 'EXPENSE_VOUCHER',
  },

  {
    label: 'Quản trị',
    isTitle: true,
  },
  // {
  //   id: 'shift-schedule-management',
  //   label: 'Shift Schedule Management',
  //   link: '/shift-schedule-management',
  //   icon: <Calendar />,
  // },
  {
    id: 'pump-management',
    label: 'Số công tơ lít',
    link: '/pump-management',
    icon: <Gauge />,
    permissionFeature: 'PUMP',
  },
  {
    id: 'inventory-setup',
    label: 'Thiết lập vật tư',
    link: '/inventory/setup',
    icon: <Package />,
    permissionFeature: 'PRODUCT',
  },
  {
    id: 'service-setup',
    label: 'Thiết lập dịch vụ',
    link: '/service/setup',
    icon: <ShoppingBag />,
    permissionFeature: 'SERVICE',
  },
  {
    id: 'account-management',
    label: 'Quản lý tài khoản',
    link: '/account-management',
    icon: <Users />,
    permissionFeature: 'ACCOUNT_MANAGEMENT',
  },
  {
    id: 'system-history',
    label: 'Lịch sử hệ thống',
    link: '/system-history',
    icon: <Clock />,
    permissionFeature: 'HISTORY',
  },
];

export { menuData };

